
export default function externalLink(event, url) {
    event.preventDefault();
    window.open(url,'_blank','noopener noreferrer');
}